import { useEffect, useState } from "react";
/**
 * Cosmos has no announce protocol like EIP-6963 or the Wallet Standard, so discovery is probing
 * well-known window keys. Every probed extension exposes the Keplr API shape.
 */
const PROBES = [
    { key: "keplr", name: "Keplr" },
    { key: "leap", name: "Leap" },
];
const NO_WALLETS = [];
function injectedAt(key) {
    const candidate = window[key];
    return typeof candidate?.enable === "function" ? candidate : undefined;
}
/** Probes the window for Keplr-API wallets. Exported for apps that want the list without the hook. */
export function detectCosmosWallets() {
    if (typeof window === "undefined")
        return NO_WALLETS;
    return PROBES.filter((probe) => injectedAt(probe.key)).map((probe) => ({
        id: `cosmos:${probe.key}`,
        name: probe.name,
    }));
}
/**
 * Discovers injected Cosmos wallets for {@link useProviderPairing}'s `sources`.
 *
 * Discovery only: after `onConnect` the app owns the Keplr handle, its signers, and its
 * lifecycle.
 */
export function useCosmosSource({ chainIds, onConnect, onError }) {
    const [wallets, setWallets] = useState(NO_WALLETS);
    const [connected, setConnected] = useState(false);
    useEffect(() => {
        const detect = () => setWallets(detectCosmosWallets());
        detect();
        window.addEventListener("load", detect);
        return () => window.removeEventListener("load", detect);
    }, []);
    const connect = (wallet) => {
        const probe = PROBES.find((candidate) => `cosmos:${candidate.key}` === wallet.id);
        const handle = probe && injectedAt(probe.key);
        if (!handle) {
            onError?.(new Error(`${wallet.name} is no longer available in this browser.`));
            return;
        }
        void handle
            .enable([...chainIds])
            .then(() => {
            setConnected(true);
            onConnect(handle);
        })
            .catch((e) => onError?.(e instanceof Error ? e : new Error(String(e))));
    };
    return { wallets, connect, connected };
}
//# sourceMappingURL=index.js.map